import React from "react";

export const Screen = React.forwardRef<
    HTMLDivElement,
    React.HTMLAttributes<HTMLDivElement>
>(({ children, className, ...rest }, ref) => {
    return (
        <div
            ref={ref}
            {...rest}
            className={
                "app min-h-screen bg-secondary-blue-lightest " + className ?? ""
            }
        >
            {children}
        </div>
    );
});
